// !important: Use this for all modal content and display control

export const modalCore = (modalName) => {
    // get global component
    const modalElm = window.fusionElements.modal;

    // empty elements from component
    modalElm.innerHTML = '';

    // get the content that is going to be injected into the modal
    const modalContent = document.getElementById(modalName);
    modalElm.insertAdjacentHTML('beforeend', modalContent.innerHTML);

    // only want to unhide the conent inside the modal itself and not the content that is placed on the page
    const loadedInnerContent = modalElm.querySelector('.fusion-modal-content-wrapper');
    loadedInnerContent.classList.remove('fusion-modal-wrapper--hidden');
    loadedInnerContent.classList.add('fusion-modal-wrapper--active');
    

    // load modal into view
    modalElm.show();
}
